export default __webpack_public_path__ + "static/media/pc-icon-2000x2000.42b1a486.png";